import { render, staticRenderFns } from "./bankrupt.vue?vue&type=template&id=eb800bb2&scoped=true&"
import script from "./bankrupt.vue?vue&type=script&lang=js&"
export * from "./bankrupt.vue?vue&type=script&lang=js&"
import style0 from "./bankrupt.vue?vue&type=style&index=0&id=eb800bb2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb800bb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb800bb2')) {
      api.createRecord('eb800bb2', component.options)
    } else {
      api.reload('eb800bb2', component.options)
    }
    module.hot.accept("./bankrupt.vue?vue&type=template&id=eb800bb2&scoped=true&", function () {
      api.rerender('eb800bb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/bankrupt/bankrupt.vue"
export default component.exports